import React from 'react';
import '../template-file-css/document-file-template.css';


export const ACTS_IntakePacket = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='ACTS_IntakePacket' className='file-pdf-document'>
            <div className='file-template'>


                <h2>AMETHYST INTAKE PACKET </h2>
                <h4>DEMOGRAPHIC INFORMATION </h4>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Program:</span>
                            <input type='text' id='txtProgramDemo' name='txtProgramDemo' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Date of Admission:</span>
                            <input type='date' id='txtDateAdmission' name='txtDateAdmission' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Date of Discharge:</span>
                            <input type='date' id='txtDateDischarge' name='txtDateDischarge' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Patient Last Name:</span>
                            <input type='text' id='txtPatientLast' name='txtPatientLast' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>First Name:</span>
                            <input type='text' id='txtFirstName' name='txtFirstName' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Middle:</span>
                            <input type='text' id='txtMiddle' name='txtMiddle' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Marital Status:</span>
                            <input type='text' id='txtMaritalStatus' name='txtMaritalStatus' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Date of Birth:</span>
                            <input type='date' id='txtDateBirth' name='txtDateBirth' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>SSN:</span>
                            <input type='text' id='txtSSN' name='txtSSN' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Address:</span>
                            <input type='text' id='txtAddressDemo' name='txtAddressDemo' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Ethnicity/Race:</span>
                            <input type='text' id='txtEthnicity' name='txtEthnicity' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Phone Number:</span>
                            <input type='text' id='txtPhoneNumber' name='txtPhoneNumber' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Email Address:</span>
                            <input type='text' id='txtEmailAddress' name='txtEmailAddress' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Legal Guardian/Parent Name:</span>
                            <input type='text' id='txtLegalGuardian' name='txtLegalGuardian' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Relationship:</span>
                            <input type='text' id='txtRelationship' name='txtRelationship' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Phone Number:</span>
                            <input type='text' id='txtPhoneNumber1' name='txtPhoneNumber1' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Emergency Contact Name:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Relationship:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Phone Number:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbEmergencyContact' name='cbEmergencyContact' className='add-only' value='1' />check if same as resp party
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>                           
                            <input type='text' id='txtEmergencyContactName' name='txtEmergencyContactName' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtRelationship1' name='txtRelationship1' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtPhoneNumber2' name='txtPhoneNumber2' className='add-only' />
                        </td>
                    </tr>
                </table>
                <h4>ADDITIONAL INFORMATION</h4>                
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Primary Fund Source/Insurance::</span>
                            <input type='text' id='txtPrimaryFund' name='txtPrimaryFund' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Policy Number:</span>
                            <input type='text' id='txtPolicyNumber3' name='txtPolicyNumber3' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Secondary Fund Source/Insurance:</span>
                            <input type='text' id='txtSecondaryFund' name='txtSecondaryFund' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Policy Number:</span>
                            <input type='text' id='txtPolicyNumber' name='txtPolicyNumber' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Co-Payment:</span>
                            <input type='text' id='txtCoPayment' name='txtCoPayment' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>EAP Insurance:</span>
                            <input type='text' id='txtEAPInsurance' name='txtEAPInsurance' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Authorization Number:</span>
                            <input type='text' id='txtAuthorizationNumber' name='txtAuthorizationNumber' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Primary Language:</span>
                            <input type='text' id='txtPrimaryLanguage' name='txtPrimaryLanguage' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>US Citizen:</span>
                            <input type='radio' id='rbUsCitizen_Yes' name='rbUsCitizen' className='add-only' value='1' /> YES&nbsp;
                            <input type='radio' id='rbUsCitizen_No' name='rbUsCitizen' className='add-only' value='0' /> NO
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>School Name:</span>
                            <input type='text' id='txtSchoolName' name='txtSchoolName' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>School Number:</span>
                            <input type='text' id='txtSchoolNumber' name='txtSchoolNumber' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>School Address:</span>
                            <input type='text' id='txtSchoolAddress' name='txtSchoolAddress' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Highest Level of Education:</span>
                            <input type='text' id='txtHighestLevel' name='txtHighestLevel' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>County:</span>
                            <input type='text' id='txtCounty' name='txtCounty' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Employer:</span>
                            <input type='text' id='txtEmployer' name='txtEmployer' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Employer Phone:</span>
                            <input type='text' id='txtEmployerPhone' name='txtEmployerPhone' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Employer Address:</span>
                            <input type='text' id='txtEmployerAddress' name='txtEmployerAddress' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Family Household Income::</span>
                            <input type='text' id='txtFamilyHousehold' name='txtFamilyHousehold' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Household Size:</span>
                            <input type='text' id='txtHouseholdSize' name='txtHouseholdSize' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Allergies:</span>
                    <textarea id='txtAllergies' name='txtAllergies' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Medications:</span>
                    <textarea id='txtMedications' name='txtMedications' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Sexual Orientation:</span>
                            <input type='text' id='txtSexualOrientation' name='txtSexualOrientation' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Gender Identity:</span>
                            <input type='text' id='txtGenderIdentity' name='txtGenderIdentity' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Pronouns:</span>
                            <input type='text' id='txtPronouns' name='txtPronouns' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Primary Care Physician/Address:</span>
                            <input type='text' id='txtPrimaryCareAddress' name='txtPrimaryCareAddress' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Primary Care Phone Number:</span>
                            <input type='text' id='txtPrimaryCareNumber' name='txtPrimaryCareNumber' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Have you received mental health services in the past 12 months?</span>
                    <input type='radio' id='rbHealthService_Yes' name='rbHealthService' className='add-only' value='1' /> YES&nbsp;
                    <input type='radio' id='rbHealthService_No' name='rbHealthService' className='add-only' value='0' /> NO <br />
                    If yes, name of agency/services:
                    <textarea id='txtHealthService' name='txtHealthService' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Emergency Hospital of Choice:</span>
                            <input type='text' id='txtEmergencyHospital' name='txtEmergencyHospital' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Psychiatrist:</span>
                            <input type='text' id='txtPsychiatrist' name='txtPsychiatrist' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Psychiatrist Phone Number:</span>
                            <input type='text' id='txtPsychiatristNumber' name='txtPsychiatristNumber' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    I, <input type='text' id='txtInfoAccuracy' name='txtInfoAccuracy' className='add-only w-250 custom-add-only' />, have reviewed and attest to the accuracy of the information.
                </p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp;</td>
                        <td className='signature w-375'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small  w-375'>Signature</td>
                        <td className='small  w-375'>Date</td>
                    </tr>
                </table>


            </div>
        </form>

    )
}  
